import { IconsModule } from './../icons/icons.module';
import { SharedModule } from '@app/shared/shared.module';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { SendRateAndCommentComponent } from './send-rate-and-comment.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [SendRateAndCommentComponent],
  imports: [
    CommonModule,
    ContainerScrollModule,
    SharedModule,
    IconsModule
  ],
  exports: [SendRateAndCommentComponent]
})
export class SendRateAndCommentModule { }
